/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2015
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define(['./Button', 'jquery', 'underscore' ], function(View, $, _) {

	var DropDownView = null;

	/**
	 * Represents a drop down that can be added to the toolbar and that can be used to show any view in the drop down
	 */
	DropDownView = View.extend({
		baseClass: 'toolbar',

		events: {
			'click .dropDownContainer': '_stopPropagation'
		},

		/**
		 * Creates a new button that will show a dropdown view
		 *
		 * @param spec -
		 *            The menu item spec
		 */
		init: function(spec) {
			this.spec = spec;
			spec.arrow = true;
			_.extend(this, spec);
			DropDownView.inherited('init', this, arguments);
		},

		render: function() {
			DropDownView.inherited('render', this, arguments);

			this.$toggle = this.$el.children('button');
			this.$toggle.attr('data-toggle', 'dropdown');

			this.$el
				.addClass('dropdown')
				.append('<div class="dropdown-menu dropDownContainer"></div>');

			return new Promise((resolve, reject) => {
				require([ 'bsdropdown' ], resolve, reject);
			}).then(() => {
				this.$toggle.dropdown();
				this.$el.on('show.bs.dropdown', () => {
					if(this.action) {
						this.action.apply(this, arguments);
					}

					this.view.$el.appendTo(this.$('.dropDownContainer'));
					this.view.render();

					if (this.position === 'trailing') {
						this.$('.dropDownContainer').addClass('dropdown-menu-right');
					}
				});
			});
		},

		_stopPropagation: function() {
			return false;
		}

	});

	return DropDownView;
});
